import { CellContext } from '@tanstack/react-table'
import { FieldArrayWithId } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { getViewportWidthCellText } from 'features/inventory/ad-unit/utils'
import { Schema } from '../../../../../schema'

export const ViewportWidthCell = ({
  row: { index },
  table: { getRowModel },
}: CellContext<FieldArrayWithId<Schema>, unknown>): string => {
  const { t } = useTranslation('features/adUnit', {
    keyPrefix:
      'form.refresher.refreshRedirect.columns.refreshSizes.viewportList.cells.viewportWidth',
  })

  return getViewportWidthCellText({
    errorMessage: 'Could not match Refresh Size viewport range',
    index,
    rows: getRowModel().rows,
    t,
  })
}
